import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Box,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link as RouterLink } from "react-router-dom";

const StyledCard = styled(Card)(({ theme }) => ({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  boxShadow: theme.shadows[2],
}));

const StyledCardMedia = styled(CardMedia)<{ imageposition?: string }>(
  ({ imageposition }) => ({
    paddingTop: "56.90p%", // 16:9 aspect ratio
    padding: "90px", 
    backgroundSize: "374px",
    backgroundPosition: imageposition || "center center",
  })
);

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(2),
  "&:last-child": {
    paddingBottom: theme.spacing(2),
  },
}));

const StyledList = styled(List)(({ theme }) => ({
  padding: 0,
  marginTop: theme.spacing(1),
}));

const StyledListItem = styled(ListItem)(({ theme }) => ({
  padding: 0,
  marginBottom: theme.spacing(0.5),
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: "auto",
  marginRight: theme.spacing(1),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: "auto", // This pushes the button to the bottom
  backgroundColor: '#00537E',
}));

interface CourseBoxProps {
  title: string;
  description: string;
  imageSrc: string;
  imagePosition?: string;
  registerLink: string;
  registerButtonTitle?: string;
  linkActive?: boolean;
  onClick?: () => void;
  secondaryButtonAction?: () => void,
  secondaryButtonTitle?: string;
}

const CourseBox: React.FC<CourseBoxProps> = ({
  title,
  description,
  imageSrc,
  imagePosition = "center center",
  registerLink,
  registerButtonTitle = "See Class Locations and Register",
  linkActive = true,
  onClick = Function.prototype(),
  secondaryButtonAction = null,
  secondaryButtonTitle = null
}) => (
  <StyledCard id={title}>
    <StyledCardMedia
      image={imageSrc}
      title={title}
      imageposition={imagePosition}
    />
    <StyledCardContent>
      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        style={{ marginTop: -15, color: "#00537E" }}
      >
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" style={{marginBottom: "10px"}}>
        {description}
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      {linkActive ? (
        <RouterLink to={onClick ? "" : registerLink} style={{ textDecoration: "none" }}>
          <StyledButton variant="contained" color="primary" fullWidth style={{ fontSize: "16px" }} onClick={onClick}>
            {registerButtonTitle}
          </StyledButton>
        </RouterLink>
      ) : (
        <StyledButton variant="contained" color="primary" fullWidth disabled style={{ fontSize: "16px" }}>
          {registerButtonTitle}
        </StyledButton>
      )}
      &nbsp;
      {secondaryButtonAction ? (
          <StyledButton variant="contained" color="primary" fullWidth style={{ fontSize: "16px" }} onClick={secondaryButtonAction}>
            {secondaryButtonTitle}
          </StyledButton>
      ) : null}
    </StyledCardContent>
  </StyledCard>
);

export default CourseBox;
